/**
 * @format
 */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getGalleryListAPI, Gallery } from '../api/adserver';
import { RootState } from './rootReducer';
import { AppThunk } from './store';

interface GalleryState {
  loading: boolean;
  isSucess: boolean;
  errMsg: string | null;
  data: Array<Gallery>;
}

const initialState: GalleryState = {
  loading: false,
  isSucess: false,
  errMsg: null,
  data: [],
};

const gallerySlice = createSlice({
  name: 'Gallery',
  initialState,
  reducers: {
    fetchGalleryListProcessing(state) {
      return { ...state, loading: true };
    },
    fetchGalleryListSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        isSucess: true,
      };
    },
    fetchGalleryListFailed(state, action: PayloadAction<string>) {
      return { ...state, loading: false, errMsg: action.payload };
    },
  },
});

export const {
  fetchGalleryListProcessing,
  fetchGalleryListSuccess,
  fetchGalleryListFailed,
} = gallerySlice.actions;

export const selectGallery = createSelector(
  (state: RootState) => state.gallery,
  (GalleryState: GalleryState) => {
    return {
      ...GalleryState,
    };
  },
);

export const getGalleryList = (): AppThunk => async (dispatch) => {
  try {
    dispatch(fetchGalleryListProcessing());
    const data = await getGalleryListAPI();
    dispatch(fetchGalleryListSuccess(data));
  } catch (err: unknown) {
    let message = 'unknown error';
    if (err instanceof Error) {
      message = err.toString();
    }
    dispatch(fetchGalleryListFailed(message));
  }
};

export default gallerySlice.reducer;
